<template>
  <div class="inlibrary" data-mu-loading-color="secondary" data-mu-loading-overlay-color="rgba(0, 0, 0, .7)" v-loading="loading">
    <my-head :title="title" :isRightClick = "true"/>
    
    <mu-text-field v-model="vin" placeholder="VIN" ref="vin" class='input' @keyup.enter.native="searchVin()"><i class="iconfont icon-saomiao" @click="scan('vin')"></i></mu-text-field>
    
    <mu-paper class="paper" :z-depth="2" v-if="from=='inlibrary'" v-for="item in libraryList">
        <div class="list-content">VIN ：<span>{{item.vin}}</span></div>
        <div class="list-content">状态：<span>{{item.status}}</span></div>
        <div class="list-content">入库时间：<span>{{item.inWarehouseTime}}</span></div>
        <div class="list-content">车辆类型：<span>{{item.carType}}</span></div>
        <div class="list-content">车型名称：<span>{{item.itemName}}</span></div>
        <div class="list-content">配置代码：<span>{{item.extendPropC1}}</span></div>
        <div class="list-content">库位：<span>{{item.location}}</span></div>
        <div class="list-content">驾驶员：<span>{{item.workerName}}</span></div>
        <!-- <div class="list-content">配置代码：<span><mu-text-field class="library-position" v-model="infoForm.location"></mu-text-field></span></div> -->
    </mu-paper>

    <mu-paper class="paper" :z-depth="2" v-if="from=='outlibrary'" v-for="item in libraryList">
        <div class="list-content">VIN ：<span>{{item.vin}}</span></div>
        <div class="list-content">状态：<span>{{item.status}}</span></div>
        <div class="list-content">车型名称：<span>{{item.vehicleType}}</span></div>
        <div class="list-content">颜色名称：<span>{{item.color}}</span></div>
        <div class="list-content">配置名称：<span>{{item.config}}</span></div>
        <div class="list-content">任务类型：<span>{{item.taskType}}</span></div>
        <div class="list-content">取车库位：<span>{{item.pickLocation}}</span></div>
        <div class="list-content">发货库位：<span>{{item.targetLocation}}</span></div>
        <div class="list-content">备注详情：<span>{{item.remark}}</span></div>
        <!-- <div class="list-content">库位：<span><mu-text-field class="library-position" v-model="infoForm.location"></mu-text-field></span></div> -->
    </mu-paper>

    <div class="btn">
        <mu-button large color="primary" v-if="doneBtn"  @click="goBackTask">回退任务</mu-button>
    </div>

    <div class="btn">
        <mu-button large v-if="refuseBtn" color="primary" @click="openBottomSheet()">拒绝任务</mu-button>
        <!-- <mu-button large v-if="abnormal" color="primary" @click="goAbnormal">异常上报</mu-button> -->
        <mu-button large v-if="receiveBtn" color="primary" @click="driverAction(1)">领取任务</mu-button>
        <mu-button large v-if="pickCarBtn" color="primary" @click="driverAction(2)">取车确认</mu-button>
        <mu-button large v-if="doneBtn" color="primary" @click="isDoneUpdate">确认完成</mu-button>
    </div>

    <mu-bottom-sheet :open.sync="openRefuseReasons">
        <mu-list @item-click="closeBottomSheet">
            <mu-sub-header>请拒绝原因</mu-sub-header>
            <mu-list-item button v-for="(item,index) in refuseReasons" :key="index" @click="driverAction(0, item.reason)">
                <mu-list-item-title>{{item.reason}}</mu-list-item-title>
            </mu-list-item>
        </mu-list>
    </mu-bottom-sheet>
    <mu-dialog title="是否确认完成?" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="isuredoneDialog">
        <mu-button slot="actions" flat color="primary" @click="sureDone()">是</mu-button>
        <mu-button slot="actions" flat color="primary" @click="closeThisConfirm">否</mu-button>
    </mu-dialog>
    <!-- <div class="targetLocation" ref="test" @click="watchTest">
        当前库位坐标
        <div>经：{{longitude}}</div>
        <div>纬：{{latitude}}</div>
        <div>半径：{{railRadius}}</div>
        <div>距离：{{lengths}}</div>
    </div> -->
    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing"/>
  </div>
</template>

<script>
import myHead from '@/components/header'
import scanning from "@/components/scanning"
import api from "@/common/api"
export default {
  name: 'inlibrary',
  components: {
    myHead, scanning
  },
  data () {
    return {
        title: "",
        scanMark: '',
        loading: true,
        isScanning: false,
        iswatchTest: false,
        isuredoneDialog: false,
        from: "",
        vin: "",
        taskid: "",
        surevin: '',
        openRefuseReasons: false,
        targetReservoirArea: '',
        options: [{areaId: '', areaName: ''}],
        refuseReasons: [],
        isSureVin: false,
        isShowVin: false,
        isShowCard: false,
        refuseBtn: false,
        receiveBtn: false,
        pickCarBtn: false,
        doneBtn: false,
        infoForm: {
            carCode: "",
            color: "",
            type: "",
            location: ""
        },
        abnormal: false,
        latitude: 0,
        longitude: 0,
        libraryList: [],
        libraryListTotal: [],
        railRadius: 10,
        lengths: 0,
        requestOnce: true,
        isDisCompute: true,
        isAutoDone: true // 是否自动完成
    }
  },
  methods: {
    changeSelector(){
        window.localStorage.setItem("targetReservoirArea", this.targetReservoirArea);
    },
    storageQueryRecord(){
        
    },
    searchVin(){
        this.loading = true;
        this.libraryList = [];
        let time = Math.random()*1500;
        console.log(time);
        setTimeout(() => {
            this.libraryListTotal.forEach(element => {
                if(element.vin.indexOf(this.vin) >= 0){
                    this.libraryList.push(element);
                }
            });
            this.loading = false;
        }, time);
    },
    initSearch(type){
        let manger = type == 'inlibrary' ? "storageQueryRecord" : "taskCancelQueryRecord";
        let data = Object.assign({},this.$store.state.user,{
            content: {
            }
        });
        // return
        /* 发送post请求 */
        this.common.reqData(api.app(manger), data, res=>{
            console.log('查询成功：',res.data);
            this.loading = false;
            if(res.data.status == 100){
                this.Toast.success({
                    duration: 3000,
                    mask: true,
                    message: "查询成功"
                });
                this.libraryListTotal = this.libraryList = res.data.content.list || [];
            }else{
                this.Toast({
                    mask: true,
                    message: res.data.msg
                });
            }
        },err =>{
            console.log(err)
        });
    },
    goBackTask(){
        // 回退任务
        console.log("回退任务");
        if(this.isAutoDone){
            this.isAutoDone = false;
            let data = Object.assign({},this.$store.state.user,{
                content: {
                    vin : this.vin,
                    taskid: this.taskid,
                    location: this.infoForm.location
                }
            });
            /* 发送post请求 */
            this.common.reqData(api.app('inlibraryCancel'), data, res=>{
                this.isAutoDone = true;
                console.log('回退任务成功',res.data);
                if(res.data.status == 100){
                    this.Toast.success({
                        duration: 3000,
                        mask: true,
                        message: "回退任务成功"
                    });
                    this.abnormal = this.doneBtn = false;
                    // manual == "RAIL" ? this.common.tts("任务已自动完成") : 0;
                    this.longitude = this.latitude = 0;
                    this.isDisCompute = false;
                    this.refuseBtn = this.abnormal = this.receiveBtn = this.pickCarBtn = this.doneBtn = 
                    this.isShowCard = false;
                    this.isShowVin = true;
                }else{
                    this.Toast({
                        mask: true,
                        message: res.data.msg
                    });
                }
            },err =>{
                this.isAutoDone = true;
                console.log(err)
            });
        }else{
            return false;
        }
    },
    closeing (val) {
      val ? this.isScanning = false : null;
    },
    childByValue (val) {
      if(val){
        console.log("val", val);
        if(val.split('&')[1] == 'showVin'){
          this.vin = val.split('&')[0];
          this.getVin();
        }else if(val.split('&')[1] == 'sureVin'){
          this.surevin = val.split('&')[0];
          this.driverAction(2);
        }else if(val.split('&')[1] == "vin"){
            this.vin = val.split('&')[0];
            this.searchVin();
        }
      }
    },
    scan (txt) {
      this.scanMark = txt;
      this.isScanning = true;
    },
    watchTest(){
      if(this.iswatchTest){
        this.$refs.test.classList.remove('hover')
      }else{
        this.$refs.test.classList.add('hover')
      }
      this.iswatchTest = !this.iswatchTest;
    },
    /* 异常跳转 */
    goAbnormal () {
      this.$router.push({name: "abnormal", params: {vin: this.vin}});
    },
    /*手动确认完成 */
    isDoneUpdate () {
        this.doneUpdate('MANUAL');
        // this.disCompute("MANUAL", ()=>{
        //     // 在电子围栏半径内
        //     this.isuredoneDialog = true;
        // });
    },
    sureDone(){
        this.doneUpdate('MANUAL');
        this.isuredoneDialog = false;
    },
    closeThisConfirm(){
        this.isuredoneDialog = false;
    },
    /*确认完成 */
    doneUpdate (manual) {
        console.log(this.isAutoDone)
        if(this.isAutoDone){
            this.isAutoDone = false;
            let data = Object.assign({},this.$store.state.user,{
                content: {
                    vin : this.vin,
                    action: manual,
                    location: this.infoForm.location
                }
            });
            /* 发送post请求 */
            this.common.reqData(api.app('inlibraryConfirm'), data, res=>{
                this.isAutoDone = true;
                console.log('res.data5',res.data);
                if(res.data.status == 100){
                    this.Toast.success({
                        duration: 1500,
                        mask: true,
                        message: "入库成功"
                    });
                    this.abnormal = this.doneBtn = false;
                    // manual == "RAIL" ? this.common.tts("任务已自动完成") : 0;
                    this.longitude = this.latitude = 0;
                    this.isDisCompute = false;
                    this.refuseBtn = this.abnormal = this.receiveBtn = this.pickCarBtn = this.doneBtn = 
                    this.isShowCard = false;
                    this.isShowVin = true;
                }else{
                    this.Toast({
                        mask: true,
                        message: res.data.msg
                    });
                }
            },err =>{
                this.isAutoDone = true;
                console.log(err)
            });
        }else{
            return false;
        }
    },
    closeBottomSheet () {
        this.openRefuseReasons = false;
    },
    openBottomSheet () {
        this.openRefuseReasons = true;
    },
    /*领取 和 取车确认 拒绝任务 */
    driverAction (flag, reason) {
        let data = null;
        if(this.surevin == ''){
            data = Object.assign({},this.$store.state.user,{
                content: {
                    vin: this.vin,
                    flag: flag,
                    issurevin: false
                }
            });
        }else{
            data = Object.assign({},this.$store.state.user,{
                content: {
                    vin: this.surevin,
                    flag: flag,
                    issurevin: true
                }
            });
        }
        if(flag === 0){
            // 如果是拒绝，那么请选择拒绝原因
            data = Object.assign({},this.$store.state.user,{
                content: {
                    vin: this.vin,
                    flag: flag,
                    issurevin: false,
                    reason: reason
                }
            });
        }
        if(this.requestOnce){
            this.requestOnce = false;
            /* 发送post请求 */
            this.common.reqData(api.app('inlibraryUpdate'), data, res=>{
                console.log('res.data4',res.data);
                this.requestOnce = true;
                if(res.data.status == 100){
                    if(flag == 0){
                        this.pickCarBtn = false,
                        this.refuseBtn = false,
                        this.receiveBtn = false,
                        this.isShowVin = false;
                        // 提示
                        this.Toast({
                            duration: 1500,
                            mask: true,
                            message: '已拒绝任务'
                        });
                    }else if(flag == 1){
                        this.abnormal = true;
                        this.pickCarBtn = true,
                        this.refuseBtn = false,
                        this.receiveBtn = false,
                        this.isShowVin = false;
                        // 提示
                        this.Toast({
                            duration: 1500,
                            mask: true,
                            message: '已领取任务'
                        });
                    }else{
                        // 提示
                        this.Toast({
                            duration: 1500,
                            mask: true,
                            message: '已取车'
                        });
                        this.refuseBtn = false,
                        this.receiveBtn = false,
                        this.isShowVin = false;
                        this.isSureVin = false;
                        this.pickCarBtn = false,
                        this.doneBtn = true;
                        this.abnormal = true;
                        this.latitude = res.data.content.latitude;
                        this.longitude = res.data.content.longitude;
                        this.railRadius = res.data.content.railRadius;
                        this.infoForm.location = res.data.content.location;
                    }
                }else{
                    this.Toast({
                        mask: true,
                        message: res.data.msg
                    });
                }
            },err =>{
                this.requestOnce = true;
                console.log(err)
            });
        }
    },
    getVin () {
        let data = Object.assign({},this.$store.state.user,{
            content: {
                vin: this.vin,
                TLId: this.targetReservoirArea
            }
        });
        if(this.requestOnce){
            this.requestOnce = false;
            /* 发送post请求 */
            this.common.reqData(api.app('inlibraryVin'), data, res=>{
                console.log('res.data3',res.data);
                this.requestOnce = true;
                if(res.data.status == 100){
                    this.infoForm = {
                        carCode: res.data.content.vehicleType,
                        color: res.data.content.color,
                        type: res.data.content.type,
                        config: res.data.content.config,
                        location: res.data.content.location
                    }
                    this.latitude = res.data.content.latitude;
                    this.longitude = res.data.content.longitude;
                    this.railRadius = res.data.content.railRadius;
                    this.isShowVin = false;
                    this.doneBtn = true, this.abnormal = true, this.isShowCard = true;
                    this.isDisCompute = true;
                }else{
                    this.Toast({
                        mask: true,
                        message: res.data.msg
                    });
                }
            },err =>{
                this.requestOnce = true;
                console.log(err)
            });
        }
    },
    searchTask (data) {
        /* 发送post请求 */
        this.common.reqData(api.app('inlibrary'), data, res=>{
            console.log('res.data1',res.data);
            let resData = res.data.content;
            if(res.data.status == 100){
                if(resData.task == null){
                    this.isShowVin = true;
                    setTimeout(() => {
                        // 获取焦点
                        this.$refs.vin.$el.children[0].getElementsByTagName('input')[0].focus();
                        window.plus ? plus.key.hideSoftKeybord() : 0;
                    }, 50);
                    return ;
                }else{
                    this.taskid = res.data.content.task.taskid || "";
                }
                if(resData.task.flag == 0){
                    this.resContent(res);
                    this.isShowCard = true;
                    this.refuseBtn = true, this.receiveBtn = true;
                }else if(resData.task.flag == 1){
                    // 取车确认
                    this.resContent(res);
                    this.isShowCard = true;
                    this.isSureVin = true;
                    this.pickCarBtn = true;
                    this.abnormal = true;
                }else if(resData.task.flag == 2){
                    // 确认完成
                    this.abnormal = true;
                    this.doneBtn = true, this.isShowCard = true;
                    this.resContent(res);
                }
            }else{
                console.log('失败');
            }
        },err =>{
            console.log(err)
        });
    },
    resContent (res) {
        // 获取数据
        this.latitude = res.data.content.task.latitude;
        this.longitude = res.data.content.task.longitude;
        this.railRadius = res.data.content.task.railRadius;
        this.vin = res.data.content.task.vin;
        this.infoForm = {
            carCode: res.data.content.task.vehicleType,
            color: res.data.content.task.color,
            type: res.data.content.task.type,
            config: res.data.content.task.config,
            location: res.data.content.task.location
        }
    },
    disCompute (manual, func) {
      if(this.isDisCompute){
        console.log('定位或速度已经改变',this.longitude,this.latitude)
        this.common.distanceCompute({
            latitude: this.$store.state.latitude,
            longitude: this.$store.state.longitude
        },{
            latitude: this.latitude,
            longitude: this.longitude
        }, this.railRadius, ()=>{
            this.doneUpdate(manual)
        }, func);
        // 测试用距离计算
        let _this = this;
        let selfPoint = new plus.maps.Point(this.longitude, this.latitude)
        let targetPoint = new plus.maps.Point(this.$store.state.longitude, this.$store.state.latitude)
        plus.maps.Map.calculateDistance(targetPoint, selfPoint, function (event) {
            var distance = event.distance // 转换后的距离值
            _this.lengths = distance
        }, function (e) {
            console.log('Failed:' + JSON.stringify(e))
        })
      }
    },
    getLocation(){
        // 获取库区
        let data = Object.assign({},this.$store.state.user,{
            content: {
            }
        });
        this.common.reqData(api.app('shiftAreaQuery'), data, res=>{
          console.log("获取库区", res.data);
          if(res.data.status == 100){
            this.options = this.options.concat(res.data.content.areas) || [];
            this.targetReservoirArea = parseInt(window.localStorage.getItem("targetReservoirArea"));
          }else{
            this.Toast({
                duration: 2000,
                mask: true,
                message: res.data.msg
            });
          }
        },err =>{
            console.log(err)
        });
    }
  },
  mounted () {
    // let data = null;
    // if(this.$route.params.vin){
    //   data = Object.assign({},this.$store.state.user,{
    //     content:{
    //       vin: this.$route.params.vin
    //     }
    //   });
    // }else{
    //   data = this.$store.state.user;
    // }
    this.from = this.$route.query.from;
    this.title = this.from == 'inlibrary' ? '入库记录' : '出库记录';
    this.initSearch(this.$route.query.from);
    // this.getLocation();
    // // 搜索是否有未完成的入库任务
    // this.searchTask(data);
    // 拒绝原因
    // this.refuseReasons = this.$store.state.refuseReasons;
  },
  computed: {
    latitudeChange () {
        return this.$store.state.latitude;
    },
    longitudeChange () {
        return this.$store.state.longitude;
    },
    speedChange () {
        return this.$store.state.speed;
    }
  },
  watch:{
    latitudeChange: function(data) {
        this.disCompute("RAIL");
    },
    longitudeChange: function(data) {
        this.disCompute("RAIL");
    },
    speedChange: function(data) {
        this.disCompute("RAIL");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inlibrary{
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
}
.input{
    display: block;
    margin: 15px auto;
    width: 85%;
}
.paper, .state, .msg{
    width: 85%;
    margin: 4em auto 0;
    padding: 1.5em 0;
}
.state, .msg{
    text-align: center;
    color: red;
    font-size: 1em;
}
.list-content{
    padding: 8px 20px;
}
.library-position{
    font-size: 2.2em;
    font-weight: bold;
    color: red;
    text-shadow: 2px 2px 5px rgba(0,0,0,0.5);
}
.space{
    padding: 0 20px;
}
.btn{
  /* position: absolute; */
  margin: 20px 0 0;
  bottom: 20px;
  left: 7.5%;
  right: 7.5%;
  display: flex;
  justify-content: space-around;
}
.btn .mu-raised-button{
  font-size: 18px;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/inoutlibrary/brarylist.vue